import React, { useContext } from "react";
import { IconButton, Tooltip } from "@mui/material";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import { StyleContext } from "../../context/styleContext";

export default function ThemeToggle({ className, size = "small" }) {
  const { colorMode, toggleColorMode } = useContext(StyleContext);
  const isDark = colorMode === "dark";

  return (
    <Tooltip title={isDark ? "Switch to light mode" : "Switch to dark mode"}>
      <IconButton
        className={className}
        size={size}
        onClick={toggleColorMode}
        aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
        sx={{
          color: "inherit",
          border: (theme) => `1px solid ${theme.palette.divider}`,
          borderRadius: 1,
          ml: 1,

          "&:hover": {
            backgroundColor: (theme) =>
              theme.palette.mode === "dark"
                ? "rgba(34, 211, 238, 0.12)"
                : "rgba(64, 67, 172, 0.08)",
          },
        }}
      >
        {isDark ? (
          <LightModeOutlinedIcon fontSize="small" />
        ) : (
          <DarkModeOutlinedIcon fontSize="small" />
        )}
      </IconButton>
    </Tooltip>
  );
}
